
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scheduling/my-calendar",
      function () {
        return require("private-next-pages/scheduling/my-calendar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scheduling/my-calendar"])
      });
    }
  